import React from 'react';

export const BrandLogo = ({ size = 'w-8 h-8', showText = true, textClass = 'text-lg' }) => (
    <span className="flex items-center gap-2.5 shrink-0" data-testid="brand-logo">
        <img src="/logo-96.png" alt="" width="32" height="32" className={`${size} rounded-lg`} />
        {showText && (
            <span className={`${textClass} font-bold tracking-tight whitespace-nowrap`} style={{ fontFamily: "'Fraunces', serif" }}>
                The Room
            </span>
        )}
    </span>
);

export default BrandLogo;
